
export function initHomeMethod(main: HTMLElement) {

	main.querySelectorAll('[data-part="start"]').forEach(
		(d) => {
			d.addEventListener('click', (e) => {
				window['OJNew'].showFreeCoursePopup();
				e.preventDefault();
			})
		}
	)

	let o = new IntersectionObserver(
		(es) => {
			es.forEach(
				(e) => {
					if (e.isIntersecting) {
						o.disconnect();
						run();
					}
				}
			)
		},
		{
			rootMargin: '-20% 0px -20% 0px'
		}
	);

	o.observe(main)

	function run() {
		main.classList.remove('before');
		console.log('home-online run');
	}

}
